import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { motion, useAnimation } from 'framer-motion';
import NestTop from 'products/global/assets/img/nest/nest-1top.png';
import NestBottom from 'products/global/assets/img/nest/nest-3bottom.png';
import NestMiddle from 'products/global/assets/img/nest/nest-2middle.png';

const BackgroundWrapper = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
`;

const NestBackgroundSection = styled.img`
  width: 100%;
  height: auto;
`;

const images = [NestTop, NestBottom, NestMiddle];

const loadImage = (src) =>
  new Promise((resolve) => {
    const loader = new Image();
    loader.onload = resolve;
    loader.src = src;
    // Failsafe
    setTimeout(resolve, 1000);
  });

const NestBackground = ({ setNestBgLoaded }) => {
  const controls = useAnimation();

  const onImagesLoaded = useCallback(async () => {
    setTimeout(() => {
      setNestBgLoaded(true);
    }, 600);
    await controls.start('finish');
  }, [controls, setNestBgLoaded]);

  useEffect(() => {
    let mounted = true;
    Promise.all(images.map(loadImage)).then(() => {
      // wait for next animation frame to ensure that
      // framer motion controls are defined in the onImagesLoaded callback
      if (mounted) requestAnimationFrame(onImagesLoaded);
    });
    return () => {
      mounted = false;
    };
  }, [onImagesLoaded]);

  const wrapperVariants = {
    finish: {
      y: 0,
      opacity: 1,
      transition: {
        y: {
          type: 'spring',
          damping: 300,
          delay: 0.6
        },

        opacity: { delay: 0.6 }
      }
    },
    start: {
      y: 20,
      opacity: 0
    }
  };

  return (
    <BackgroundWrapper variants={wrapperVariants} animate={controls} initial="start">
      <NestBackgroundSection src={NestTop} />
      <NestBackgroundSection src={NestMiddle} />
      <NestBackgroundSection src={NestBottom} />
    </BackgroundWrapper>
  );
};

NestBackground.propTypes = {
  setNestBgLoaded: PropTypes.func
};

export default NestBackground;
